import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { string, func } from 'prop-types';
import './productDetailsButton.scss';

export const ProductDetailsButton = ({ className, onClick, onMouseEnter }) => {

  return (
    <>
      <div className={`${className} view-product-details`} onMouseEnter={onMouseEnter}>
        <Button
          onClick={onClick}
          className="view-product-details__content"
          outline
        >
          View Product Details
        </Button>
      </div>
    </>
  );
};

ProductDetailsButton.propTypes = {
  className: string,
  onClick: func.isRequired,
  onMouseEnter: func.isRequired
};

ProductDetailsButton.defaultProps = {
  className: ''
};

ProductDetailsButton.displayName = 'ProductDetailsButton';
